import CompanyInfo from '@/models/CompanyInfo/CompanyInfo';

export default class CompanyInfoFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.companyName = '';
		this.corporateField = '';
		this.companyAddress = '';
		this.officePhoneNumber = '';
		this.officeFax = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			companyName : '0',
			corporateField : '0',
			companyAddress : '0',
			officePhoneNumber : '0',
			officeFax : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}